import React, { useState, useEffect, useCallback } from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  ScrollView,
  TextInput,
} from 'react-native';
import { FloatingAction } from 'react-native-floating-action';
import api from '../../services/api';

const VincularVendedor = ({ route, navigation }) => {
  const [vendedores, setVendedores] = useState([]);
  const [vendedoresFiltrados, setVendedoresFiltrados] = useState([]);
  const [termoPesquisa, setTermoPesquisa] = useState('');

  const handleObterVendedores = useCallback(async () => {
    const { data } = await api.get('vendedores');
    const v = data.sort((a, b) => a.nome.localeCompare(b.nome));
    setVendedores(v);
    setVendedoresFiltrados(v);
  }, []);

  useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      handleObterVendedores();
    });
    return unsubscribe;
  }, [navigation]);

  useEffect(() => {
    if (termoPesquisa.trim() === '') {
      setVendedoresFiltrados(vendedores);
    } else {
      const filtrados = vendedores.filter(
        (vendedor) =>
          vendedor.nome.toLowerCase().includes(termoPesquisa.toLowerCase()) ||
          vendedor.email.toLowerCase().includes(termoPesquisa.toLowerCase())
      );
      setVendedoresFiltrados(filtrados);
    }
  }, [termoPesquisa, vendedores]);

  const vincularVendedor = (vendedor) => {
    const id = route.params.id;

    api
      .post('vincularvendedor', { sorteio: id, vendedor })
      .then(() => {
        alert('Vendedor vinculado com sucesso');
        navigation.goBack();
      })
      .catch((e) => {
        if (e.response.data.msg) {
          alert(e.response.data.msg);
        } else {
          alert('Falha ao vincular vendedor ou ele ja esta vinculado');
        }
      });
  };

  const abrirCadastro = () => {
    navigation.navigate('VendedorCadastro');
  };

  return (
    <View style={{ flex: 1 }}>
      <View style={{ margin: 20, flex: 1 }}>
        <View
          style={{
            backgroundColor: '#fff',
            padding: 10,
            marginTop: 10,
            borderRadius: 5,
            marginBottom: 10,
          }}
        >
          <Text style={{ fontSize: 12, marginBottom: 5 }}>
            Pesquisar vendedor
          </Text>
          <TextInput
            style={{
              paddingTop: 5,
              paddingBottom: 5,
              paddingLeft: 5,
              borderWidth: 1,
              borderColor: '#000',
              borderRadius: 5,
            }}
            value={termoPesquisa}
            onChangeText={setTermoPesquisa}
            placeholder="Digite o nome ou email do vendedor"
          />
        </View>

        <ScrollView>
          {vendedoresFiltrados.length > 0 ? (
            vendedoresFiltrados.map((e) => (
              <TouchableOpacity
                key={e.id}
                onPress={() => vincularVendedor(e.id)}
              >
                <View
                  style={{
                    backgroundColor: '#fff',
                    padding: 10,
                    marginTop: 10,
                    borderRadius: 5,
                  }}
                >
                  <Text style={{ flex: 1, fontWeight: 'bold' }}>{e.nome}</Text>
                  <Text style={{ flex: 1 }}>{e.email}</Text>
                </View>
              </TouchableOpacity>
            ))
          ) : (
            <View
              style={{
                backgroundColor: '#fff',
                padding: 10,
                marginTop: 10,
                borderRadius: 5,
                flexDirection: 'row',
              }}
            >
              <Text style={{ flex: 1, textAlign: 'center' }}>
                {termoPesquisa.trim() === ''
                  ? 'Nenhum vendedor cadastrado'
                  : 'Nenhum vendedor encontrado'}
              </Text>
            </View>
          )}
        </ScrollView>
      </View>

      <FloatingAction
        color="#1abc9c"
        showBackground={false}
        animated={false}
        onPressMain={() => abrirCadastro()}
      />
    </View>
  );
};

export default VincularVendedor;
